import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';
import { FetchResult } from 'src/types/TApiQueries';
import type {
  ConnectedAppsListResponse,
  ConnectedAppsScope,
  SignOutAllResult,
} from 'src/types/ConnectedApps';

const BASE = `${config.hostUrl}/api/v1/oauth/sessions`;

function scopeQuery(scope: ConnectedAppsScope): string {
  if (scope.kind === 'account') return '?account=true';
  if (scope.kind === 'user') return `?user_id=${scope.userId}`;
  return '';
}

export async function getConnectedApps(
  accessToken: string,
  scope: ConnectedAppsScope,
): Promise<FetchResult<ConnectedAppsListResponse>> {
  return performFetchWithLogging<ConnectedAppsListResponse>(`${BASE}${scopeQuery(scope)}`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function signOutConnectedApp(
  accessToken: string,
  id: number,
  includeSchedules: boolean,
): Promise<FetchResult<void>> {
  const qs = includeSchedules ? '?include_schedules=true' : '';
  return performFetchWithLogging<void>(`${BASE}/${id}${qs}`, {
    method: 'DELETE',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function signOutAllConnectedApps(
  accessToken: string,
  userId: number | undefined,
  includeSchedules: boolean,
): Promise<FetchResult<SignOutAllResult>> {
  const params = new URLSearchParams();
  if (userId !== undefined) params.set('user_id', String(userId));
  if (includeSchedules) params.set('include_schedules', 'true');
  const qs = params.toString() ? `?${params}` : '';
  return performFetchWithLogging<SignOutAllResult>(`${BASE}${qs}`, {
    method: 'DELETE',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function renameConnectedApp(
  accessToken: string,
  id: number,
  label: string,
): Promise<FetchResult<{ status: string; data: { id: number; label: string | null } }>> {
  return performFetchWithLogging(`${BASE}/${id}`, {
    method: 'PATCH',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify({ label }),
  });
}
